import { LinkType } from 'fym-shared/src/smartlinks/linkTypes';
import { linkButtonLabel } from 'fym-shared/src/smartlinks/linkLabel';

/** Brand names of the social profiles. Brand names are not translated. */
const SOCIAL_NAMES: Partial<Record<LinkType, string>> = {
  [LinkType.facebook]: 'Facebook',
  [LinkType.instagram]: 'Instagram',
  [LinkType.twitter]: 'X',
  [LinkType.linkedin]: 'LinkedIn',
  [LinkType.tiktok]: 'TikTok',
  [LinkType.reddit]: 'Reddit',
  [LinkType.snapchat]: 'Snapchat',
  [LinkType.youtube]: 'YouTube',
};

/** The name of a service or a social profile type: "Spotify", "Instagram". Null for a generic link. */
export function linkTypeName(type: LinkType | string): string | null {
  const social = SOCIAL_NAMES[type as LinkType];
  if (social !== undefined) {
    return social;
  }
  const label = linkButtonLabel({ linkType: type });
  return label.kind === 'service' ? label.serviceName : null;
}
